import React, { useContext, useState } from "react";
import { Formik, Form, FieldArray } from "formik";
import { Context } from "../inc/state";
import { Actions, Radio, AutoUpdateValues, FundName } from "./fields";

import * as Yup from "yup";

import LegalEntity, { LegalEntityFormSchema, LegalEntitySchema } from "./LegalEntity";
import LegalEntityType, { LegalEntityTypeSchema } from "./LegalEntityType";
import { PersonalFields, PersonalFieldsSchema } from "./PersonalFields";

const AdditionalLegalRep = ({ group, push, pop, itemTemplate, setFieldValue }) => {
	const [count, setCount] = useState(1);

	return (
		<>
			<div className="section">
				<label htmlFor={`${group}AdditionalLegalRepresentative.0`} className="form-label">
					Is er een extra vertegenwoordiger die moet tekenen bij transacties?
				</label>

				{["Ja", "Neen"].map((item, index) => (
					<Radio
						name={`${group}AdditionalLegalRepresentative`}
						value={item}
						id={`${group}AdditionalLegalRepresentative.${index}`}
						key={`${group}AdditionalLegalRepresentative.${index}`}
						label={item}
						required
						onChange={(event) => {
							const answer = event.target.value;
							setFieldValue(`${group}AdditionalLegalRepresentative`, answer);

							if (answer === "Ja" && count < 2) {
								push(itemTemplate);
								setCount(2);
							} else if (count > 1) {
								pop();
								setCount(1);
							}
						}}
					/>
				))}
			</div>
		</>
	);
};

export default () => {
	const [state, dispatch] = useContext(Context);

	const handleSubmit = (values, { setSubmitting }) => {
		dispatch({ type: "ADD_DATA", payload: { values } });
		dispatch({ type: "STEP_FORWARD" });
	};

	const validationSchema = Yup.object().shape({
		companies: Yup.array().of(
			Yup.object()
				.shape({
					legalRepresentatives: Yup.array().of(
						Yup.object()
							.shape()
							.concat(LegalEntityTypeSchema)
							.concat(PersonalFieldsSchema)
					),
				})
				.concat(LegalEntityFormSchema)
				.concat(LegalEntitySchema)
		),
	});

	const initialValues = state.values,
		itemTemplate = state.templates.company.legalRepresentatives[0];

	return (
		<Formik
			initialValues={initialValues}
			validationSchema={validationSchema}
			onSubmit={handleSubmit}
		>
			{({ values, errors, setFieldValue }) => {
				return (
					<Form noValidate>
						<FundName title={state.fundTitle} subtitle={"Integra III Privak"} />

						<FieldArray name="companies">
							<>
								<LegalEntity
									group="companies.0."
									isBelgium={values.companies[0].land === "België"}
								/>

								<FieldArray name="companies.0.legalRepresentatives">
									{({ push, pop }) => {
										return values.companies[0].legalRepresentatives.map(
											(legalRep, index) => (
												<div key={`legalRep${index}`}>
													<div className="section">
														<h5>Gegevens bestuurder/zaakvoerder {index+1}</h5>
														<LegalEntityType
															group={`companies.0.legalRepresentatives.${index}.`}
															heading={`Hoedanigheid bestuurder/zaakvoerder ${index+1}`}
														/>
														<PersonalFields
															group={`companies.0.legalRepresentatives.${index}.`}
															isBelgium={
																values.companies[0]
																	.legalRepresentatives[index]
																	.land === "België"
															}
															isRechtspersoon={values.companies[0].legalRepresentatives[index].type!=="Natuurlijk persoon"}
														/>
													</div>

													<AdditionalLegalRep
														group={`companies.0.legalRepresentatives.${index}.`}
														push={push}
														pop={pop}
														itemTemplate={itemTemplate}
														setFieldValue={setFieldValue}
													/>
												</div>
											)
										);
									}}
								</FieldArray>
							</>
						</FieldArray>
						<AutoUpdateValues />
						<Actions />
					</Form>
				);
			}}
		</Formik>
	);
};
